// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/wellenring/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteWellenringDE: PageEntry = {
  id: "example.produkte-wellenring",
  locale: "de",
  slug: "produkte/wellenring",
  seo: {
    title: "Wellenring | Dietz GmbH",
    description: "Wellenring als Vorspannelement und Toleranzausgleich in einer Baugruppe.",
  },
  type: "post",
  h1: "Wellenring",
  intro: "Wellenring als Vorspannelement und Toleranzausgleich in einer Baugruppe.",
  blocks: [
    { kind: "image", src: "/images/live/dtz-wellenring-vorspann.jpg", alt: "Wellenring Vorspannelement", width: 1400, height: 1120 }
  ],
};
